import { Component, DoCheck, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { InputCheckboxComponent } from '../input-checkbox/input-checkbox.component';
import { ConfigService } from '../../../core/services/config.service';

@Component({
	selector: 'cfe-terms-and-conditions',
	templateUrl: './terms-and-conditions.component.html',
	styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent extends InputCheckboxComponent implements DoCheck {
	@Input() showError = true;

	inputHtml: string;

	translateSub: Subscription;

	constructor(private translateService: TranslateService, sanitizer: DomSanitizer, private configService: ConfigService) {
		super(sanitizer);
	}

	ngDoCheck() {
		this.generateCheckboxLabel();
	}

	cfeOnDestroy() {
		super.cfeOnDestroy();
		this.translateSub.unsubscribe();
	}

	public generateCheckboxLabel() {
		const termsTranslation = this.translateService.instant('terms.termsAndConditions');
		const termsLinkConfig = this.configService.config.vanityUrls.termsAndConditions;
		const termsLink = `<a href="${termsLinkConfig}" target="_blank" id="terms-and-conditions-label">${termsTranslation}</a>`;
		this.translateSub = this.translateService
			.get('terms.termsAndConditionsText', {
				termsAndConditions: termsLink
			})
			.subscribe((translation) => {
				this.inputHtml = `<b>${translation}</b>`;
			});
	}
}
